export { default } from "./useTeacherSearchQuery";
